import { render, staticRenderFns } from "./InvoiceRegistration.vue?vue&type=template&id=3db69666&"
import script from "./InvoiceRegistration.vue?vue&type=script&lang=js&"
export * from "./InvoiceRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports